import { useState, useEffect, useRef } from "react";
// import { useParams } from "react-router-dom";

// import classNames from "classnames";
import { Toast, Button, Dropdown } from "../../components/crud";
import { Conexion } from "../../service/Conexion";
// import {
// 	TablaDatos,
// 	BarraSuperior,
// 	EliminarVentana,
// 	productDialogFooter,
// } from "../../components";
// import { useDispatch, useSelector } from "react-redux";
// import { setDataSet, setFormData } from "../../store/appSlice";
import { Cargando } from "../../components/crud/Cargando";
// import { ImagenCampo } from "../../components/crud/ImagenCampo";

import { Chart } from "primereact/chart";
// import { Card } from "primereact/card";

// leonardo

export const InformeMantenimiento = () => {
	// const TABLA = "ubicacaciones";
	// let emptyFormData = {};
	// const { dataSet, formData } = useSelector((state) => state.appsesion); //datos el storage redux
	// const dispatch = useDispatch();
	// const [productDialog, setProductDialog] = useState(false);
	// const [deleteProductDialog, setDeleteProductDialog] = useState(false);
	// const [submitted, setSubmitted] = useState(false);
	const toast = useRef(null);
	// const [recargar, setrecargar] = useState(0);
	const [cargando, setCargando] = useState(false);
	const datatable = new Conexion();
	// const [dropdownTipoAliado, setdropdownTipoAliado] = useState(null);

	// let tituloiter = "Informe de Mantenimiento";

	// const [seleccionCliente, setseleccionCliente] = useState(null);
	// const [setDataInforme, setsetDataInforme] = useState(null);
	const [dropdowvnClientes, setdropdowndropdowvnClientes] = useState(null);
	const [dropdowndropdowvnSedes, setdropdowndropdowvnSedes] = useState(null);
	const [
		dropdowndropdowvnubicacion,
		setdropdowndropdowvnubicacion,
	] = useState(null);

	const [selectCliente, setselectCliente] = useState(0);
	const [selectSede, setselectSede] = useState(0);
	const [selectubucacion, setselectubucacion] = useState(0);
	const [informedatos, setinformedatos] = useState();

	const [chartData, setchartData] = useState({
		labels: ["Cancelados", "Ejecutados", "Programados"],
		datasets: [
			{
				data: [0, 0, 0],
				backgroundColor: ["#e40f19", "#66BB6A", "#FFA726"],
				hoverBackgroundColor: ["#e40f19", "#81C784", "#FFB74D"],
			},
		],
	});

	const [lightOptions] = useState({
		plugins: {
			legend: {
				labels: {
					color: "#495057",
				},
			},
		},
	});

	useEffect(() => {
		//cargar la data total

		datatable
			.gettable("parametros/cliente")
			.then((menu) => setdropdowndropdowvnClientes(menu));

		datatable
			.gettable("parametros/sede")
			.then((menu) => setdropdowndropdowvnSedes(menu));

		datatable
			.gettable("parametros/ubicacion")
			.then((menu) => setdropdowndropdowvnubicacion(menu));
	}, []);

	useEffect(() => {
		if (selectCliente) {
			datatable
				.gettable(
					"parametros/informeagendamantenimientocliente/" +
						selectCliente +
						"/" +
						selectSede +
						"/" +
						selectubucacion
				)
				.then((datos) => {
					// setsetDataInforme(datos);
					// console.log(setDataInforme);
					const labels = datos.data.resumen.map((item) => item.label);
					const totales = datos.data.resumen.map((item) =>
						parseInt(item.total)
					);
					// console.log(datos.data.informedatos);
					setinformedatos(datos.data.informedatos);

					// console.log(labels, totales);
					setchartData({
						labels: labels,
						datasets: [
							{
								data: totales,
								backgroundColor: [
									"#e40f19",
									"#66BB6A",
									"#FFA726",
								],
								hoverBackgroundColor: [
									"#e40f19",
									"#81C784",
									"#FFB74D",
								],
							},
						],
					});
				});
		}

		// console.log("clietne seleccionado", selectCliente);
	}, [selectCliente, selectSede, selectubucacion]);

	/*eventos*/

	const onDescarga = () => {
		exportExcel([...informedatos]);
	};

	const exportExcel = (datos) => {
		console.log({ datos });
		// console.log(typeof dataSet);
		import("xlsx").then((xlsx) => {
			const worksheet = xlsx.utils.json_to_sheet(datos);

			const workbook = {
				Sheets: { data: worksheet },
				SheetNames: ["data"],
			};
			const excelBuffer = xlsx.write(workbook, {
				bookType: "xlsx",
				type: "array",
			});
			saveAsExcelFile(excelBuffer, "informe-mantenimientos");
		});
	};

	const saveAsExcelFile = (buffer, fileName) => {
		let formatoPersonalizado = "";
		import("file-saver").then((module) => {
			if (module && module.default) {
				const EXCEL_TYPE =
					"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
				const EXCEL_EXTENSION = ".xlsx";
				const data = new Blob([buffer], {
					type: EXCEL_TYPE,
				});

				const fecha = new Date();
				formatoPersonalizado = `${fecha.getDate()}/${
					fecha.getMonth() + 1
				}/${fecha.getFullYear()} ${fecha.getHours()}:${fecha.getMinutes()}`;

				module.default.saveAs(
					data,
					fileName + "-" + formatoPersonalizado + EXCEL_EXTENSION
				);
			}
		});
	};

	return (
		<div className='grid'>
			<div className='col-12'>
				<div className='card'>
					<Cargando cargando={cargando} />
					<Toast ref={toast} />
					<div className='formgrid grid'>
						<div className='field col-4'>
							<label htmlFor='cod_teq_equ'>Cliente:</label>
							<Dropdown
								value={selectCliente}
								onChange={(e) => {
									setselectCliente(e.value);
								}}
								options={dropdowvnClientes}
								optionLabel='name'
								placeholder='Seleccione'
							/>
						</div>
						<div className='field col-4'>
							<label htmlFor='cod_teq_equ'>Sede:</label>
							<Dropdown
								value={selectSede}
								onChange={(e) => {
									setselectSede(e.value);
								}}
								options={dropdowndropdowvnSedes}
								optionLabel='name'
								placeholder='Seleccione'
							/>
						</div>
						<div className='field col-4'>
							<label htmlFor='cod_teq_equ'>Ubicacion:</label>
							<Dropdown
								value={selectubucacion}
								onChange={(e) => {
									setselectubucacion(e.value);
								}}
								options={dropdowndropdowvnubicacion}
								optionLabel='name'
								placeholder='Seleccione'
							/>
						</div>
						{chartData.datasets[0].data.some(
							(value) => value > 0
						) && (
							<div className='w-6 h-full p-6 surface-ground border-round'>
								<div>
									<div className=''>
										<Chart
											type='pie'
											data={chartData}
											options={lightOptions}
											style={{
												position: "relative",
												width: "90%",
											}}
										/>
										<Button
											label='Descargar Informe'
											icon='pi pi-download'
											className='p-button-raised p-button-info p-button-text'
											onClick={() => {
												onDescarga();
											}}
										/>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
